import { SubListPage } from '@/modules/tiers/components/sub-list-page'

export const NewSubsListView = () => {
  return <SubListPage />
}
